export default function PaymentezTransactionStatusError({ message }) {
  return (
    <div
      className="bg-gradient-to-t from-red-600 to-red-500 rounded-lg shadow px-4 py-2 leading-5 font-medium text-white"
      role="alert"
    >
      {message}
    </div>
  );
}
